import MainMenu from '@/components/foundation/main-menu/MainMenu'
import DocumentType from '@/view/record/document-type/DocumentType'

export default {
  path: '/document-type',
  name: 'DocumentType',
  components: {
    default: DocumentType,
    mainMenu: MainMenu
  },
  meta: {
    auth: true,
    mainArea: 'record',
    area: 'record-user',
    breadcrumb: [
      { name: 'Cadastro', link: '/record' },
      { name: 'Usuário' }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/router/record/DocumentType.js